import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface Props {
  stepScroll: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ApplicationSteps',
  props: {
    stepScroll: { default: "1" }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

__expose({
  props,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps({ class: "application-steps-wrapper" }, _ctx.$attrs), [
    _createElementVNode("div", {
      class: "application-steps",
      style: _normalizeStyle({ bottom: __props.stepScroll })
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 4)
  ], 16))
}
}

})